import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiMenu, HiX, HiChevronDown } from "react-icons/hi";
import logo from "../assets/Logo.png";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  {
    name: "Services",
    path: "/services",
    sub: [
      { name: "Web & App Development", path: "/services/web-app-development" },
      { name: "AI, Data & Automation", path: "/services/ai-data-automation" },
      { name: "SEO & Performance Marketing", path: "/services/seo-performance-marketing" },
      { name: "Branding & Creative Solutions", path: "/services/branding-creative" },
    ],
  },
  { name: "Software Solutions", path: "/software-solutions" },
  { name: "Digital Marketing", path: "/digital-marketing" },
  { name: "Industries", path: "/industries" },
  { name: "Contact Us", path: "/contact" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  // ✅ FIXED: removed TypeScript annotation
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="nav-dark sticky top-0 z-50 shadow-lg">
      <div className="container-max flex items-center justify-between px-4 sm:px-6 lg:px-8 py-3">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo}
            alt="GoPhoenix Data Solutions Logo"
            className="h-12 w-auto rounded"
          />
         
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <div key={link.name} className="relative group">
              <Link
                to={link.path}
                className={`px-3 py-2 rounded-md text-sm font-medium font-roboto flex items-center gap-1 transition-colors ${
                  isActive(link.path)
                    ? "text-primary"
                    : "text-primary-foreground/90 hover:text-primary"
                }`}
              >
                {link.name}
                {link.sub && <HiChevronDown className="w-4 h-4" />}
              </Link>

              {link.sub && (
                <div className="absolute top-full left-0 mt-1 w-64 bg-secondary rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all border border-primary-foreground/10">
                  {link.sub.map((sub) => (
                    <Link
                      key={sub.name}
                      to={sub.path}
                      className="block px-4 py-3 text-sm text-primary-foreground/80 hover:text-primary hover:bg-primary-foreground/5"
                    >
                      {sub.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}

          <Link to="/contact" className="btn-primary ml-4 text-sm py-2 px-6">
            Get a Quote
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="lg:hidden text-primary-foreground p-2"
        >
          {isOpen ? <HiX className="w-6 h-6" /> : <HiMenu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="lg:hidden bg-secondary border-t border-primary-foreground/10">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <div key={link.name}>
                <div className="flex items-center justify-between">
                  <Link
                    to={link.path}
                    onClick={() => !link.sub && setIsOpen(false)}
                    className={`block px-3 py-2 text-sm font-medium font-roboto rounded-md ${
                      isActive(link.path)
                        ? "text-primary"
                        : "text-primary-foreground/90 hover:text-primary"
                    }`}
                  >
                    {link.name}
                  </Link>

                  {link.sub && (
                    <button
                      onClick={() => setServicesOpen(!servicesOpen)}
                      className="text-primary-foreground/70 p-2"
                    >
                      <HiChevronDown
                        className={`w-4 h-4 transition-transform ${
                          servicesOpen ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                  )}
                </div>

                {link.sub && servicesOpen && (
                  <div className="pl-6 space-y-1">
                    {link.sub.map((sub) => (
                      <Link
                        key={sub.name}
                        to={sub.path}
                        onClick={() => setIsOpen(false)}
                        className="block px-3 py-2 text-sm text-primary-foreground/70 hover:text-primary"
                      >
                        {sub.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}

            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              className="btn-primary block text-sm text-center mt-4"
            >
              Get a Quote
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
